import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";

export const Marquee = () => {
  const { t } = useLang();
  const text = t(S.marquee);
  return (
    <div className="bg-cream border-y border-gold/20 py-4 overflow-hidden" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((k) => (
          <span key={k} className="flex items-center">
            {Array.from({ length: 3 }).map((_, i) => (
              <span key={i} className="flex items-center font-serif text-lg sm:text-xl text-maroon/80 italic px-6">
                {text}
                <span className="text-gold not-italic px-6">&#10070;</span>
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
};
